/**
 * @generated SignedSource<<e0460f6f62032342e3a53ea4b832444b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PianofunclubLessonStageModelLessonTypeChoices = "GROUP" | "INDIVIDUAL" | "PAIRED" | "%future added value";
export type LoadLessonBlocksQuery$variables = {
  after?: string | null | undefined;
  block?: number | null | undefined;
  blockType?: string | null | undefined;
  dayIndex?: number | null | undefined;
  first: number;
  orderBy?: string | null | undefined;
  profileId: string;
  schoolId?: string | null | undefined;
  searchTerm?: string | null | undefined;
  skipLessonBlocks: boolean;
  skipLessonStages: boolean;
  skipRegisterProgress: boolean;
  startingYear: number;
};
export type LoadLessonBlocksQuery$data = {
  readonly lessonStages?: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly costPerLesson: number | null | undefined;
        readonly id: string;
        readonly lessonDuration: number | null | undefined;
        readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
        readonly stage: number | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"LoadLessonBlocks_query_lessonBlocks" | "RegisterInfoFragment_query">;
};
export type LoadLessonBlocksQuery = {
  response: LoadLessonBlocksQuery$data;
  variables: LoadLessonBlocksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "block"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dayIndex"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profileId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schoolId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipLessonBlocks"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipLessonStages"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipRegisterProgress"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingYear"
},
v13 = {
  "kind": "Variable",
  "name": "block",
  "variableName": "block"
},
v14 = {
  "kind": "Variable",
  "name": "dayIndex",
  "variableName": "dayIndex"
},
v15 = {
  "kind": "Variable",
  "name": "profileId",
  "variableName": "profileId"
},
v16 = {
  "kind": "Variable",
  "name": "schoolId",
  "variableName": "schoolId"
},
v17 = {
  "kind": "Variable",
  "name": "startingYear",
  "variableName": "startingYear"
},
v18 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "blockType",
    "variableName": "blockType"
  },
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  (v15/*: any*/),
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  (v17/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonDuration",
  "storageKey": null
},
v21 = [
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "stage",
    "storageKey": null
  },
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lessonType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "costPerLesson",
    "storageKey": null
  }
],
v22 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v23 = {
  "condition": "skipLessonStages",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        (v13/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/)
      ],
      "concreteType": "LessonStageNodeConnection",
      "kind": "LinkedField",
      "name": "lessonStages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonStageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LessonStageNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v21/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staffNoteForTeacher",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teacherNoteForStaff",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v29 = [
  (v13/*: any*/),
  (v17/*: any*/)
],
v30 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadLessonBlocksQuery",
    "selections": [
      {
        "condition": "skipLessonBlocks",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "FragmentSpread",
            "name": "LoadLessonBlocks_query_lessonBlocks"
          }
        ]
      },
      {
        "condition": "skipRegisterProgress",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "RegisterInfoFragment_query"
          }
        ]
      },
      (v23/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v12/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadLessonBlocksQuery",
    "selections": [
      {
        "condition": "skipLessonBlocks",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "LessonBlockNodeConnection",
            "kind": "LinkedField",
            "name": "lessonBlocks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LessonBlockNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonBlockNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "block",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "keepFree",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lessonDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lessonTime",
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchoolNode",
                        "kind": "LinkedField",
                        "name": "school",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "pupil",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "schoolYear",
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "teacher",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstrumentNode",
                        "kind": "LinkedField",
                        "name": "instrument",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonStageNode",
                        "kind": "LinkedField",
                        "name": "lessonStage",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonNodeConnection",
                        "kind": "LinkedField",
                        "name": "lessons",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LessonNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LessonNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scheduledTimestamp",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "rearrangedTimestamp",
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "teacherRegisterNoteForStaff",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffRegisterNoteForTeacher",
                                    "storageKey": null
                                  },
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "weekWasRearranged",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "replacementLessonColumnIndex",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BlacklistedDateNode",
                                    "kind": "LinkedField",
                                    "name": "blacklistedDate",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "reason",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HomeworkNode",
                                    "kind": "LinkedField",
                                    "name": "homework",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "archived",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "offerAccepted",
                            "value": false
                          }
                        ],
                        "concreteType": "EnrolmentOfferNodeConnection",
                        "kind": "LinkedField",
                        "name": "enrolmentOffers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EnrolmentOfferNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EnrolmentOfferNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "archived",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "offerAccepted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EnrolmentNode",
                                    "kind": "LinkedField",
                                    "name": "enrolment",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pupilFirstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pupilLastName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "parentName",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "enrolmentOffers(archived:false,offerAccepted:false)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "filters": [
              "searchTerm",
              "startingYear",
              "block",
              "schoolId",
              "profileId",
              "dayIndex",
              "orderBy",
              "blockType"
            ],
            "handle": "connection",
            "key": "LoadLessonBlocks_query_lessonBlocks",
            "kind": "LinkedHandle",
            "name": "lessonBlocks"
          }
        ]
      },
      {
        "condition": "skipRegisterProgress",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "profileId"
              }
            ],
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": (v29/*: any*/),
                "kind": "ScalarField",
                "name": "totalLessonsMarked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "kind": "ScalarField",
                "name": "totalLessons",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "kind": "ScalarField",
                "name": "firstLessonTimestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "kind": "ScalarField",
                "name": "lastLessonTimestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "kind": "ScalarField",
                "name": "teachingDays",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      (v23/*: any*/)
    ]
  },
  "params": {
    "cacheID": "fd1edd21b0c9d422db0d65b17ff5eae1",
    "id": null,
    "metadata": {},
    "name": "LoadLessonBlocksQuery",
    "operationKind": "query",
    "text": "query LoadLessonBlocksQuery(\n  $searchTerm: String\n  $startingYear: Int!\n  $block: Int\n  $schoolId: ID\n  $profileId: ID!\n  $dayIndex: Int\n  $skipLessonBlocks: Boolean!\n  $skipRegisterProgress: Boolean!\n  $skipLessonStages: Boolean!\n  $orderBy: String\n  $first: Int!\n  $after: String\n  $blockType: String\n) {\n  ...LoadLessonBlocks_query_lessonBlocks_3luHuM @skip(if: $skipLessonBlocks)\n  ...RegisterInfoFragment_query_3Sd9eM @skip(if: $skipRegisterProgress)\n  lessonStages(schoolId: $schoolId, startingYear: $startingYear, block: $block) @skip(if: $skipLessonStages) {\n    edges {\n      node {\n        id\n        stage\n        lessonDuration\n        lessonType\n        costPerLesson\n      }\n    }\n  }\n}\n\nfragment LoadLessonBlocks_query_lessonBlocks_3luHuM on Query {\n  lessonBlocks(searchTerm: $searchTerm, startingYear: $startingYear, block: $block, schoolId: $schoolId, profileId: $profileId, dayIndex: $dayIndex, orderBy: $orderBy, first: $first, after: $after, blockType: $blockType) {\n    edges {\n      cursor\n      node {\n        id\n        block\n        keepFree\n        lessonDay\n        lessonTime\n        staffNoteForTeacher\n        teacherNoteForStaff\n        type\n        school {\n          id\n          name\n        }\n        pupil {\n          id\n          staffNoteForTeacher\n          teacherNoteForStaff\n          schoolYear\n          user {\n            firstName\n            lastName\n            id\n          }\n        }\n        teacher {\n          id\n          user {\n            firstName\n            lastName\n            id\n          }\n        }\n        instrument {\n          name\n          id\n        }\n        lessonStage {\n          id\n          stage\n          lessonDuration\n          lessonType\n          costPerLesson\n        }\n        lessons {\n          edges {\n            node {\n              id\n              scheduledTimestamp\n              rearrangedTimestamp\n              status\n              teacherRegisterNoteForStaff\n              staffRegisterNoteForTeacher\n              lessonDuration\n              weekWasRearranged\n              replacementLessonColumnIndex\n              blacklistedDate {\n                id\n                reason\n              }\n              homework {\n                id\n              }\n            }\n          }\n        }\n        enrolmentOffers(archived: false, offerAccepted: false) {\n          edges {\n            node {\n              id\n              archived\n              offerAccepted\n              enrolment {\n                id\n                status\n                pupilFirstName\n                pupilLastName\n                parentName\n              }\n            }\n          }\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RegisterInfoFragment_query_3Sd9eM on Query {\n  profile(id: $profileId) {\n    id\n    totalLessonsMarked(startingYear: $startingYear, block: $block)\n    totalLessons(startingYear: $startingYear, block: $block)\n    firstLessonTimestamp(startingYear: $startingYear, block: $block, dayIndex: $dayIndex)\n    lastLessonTimestamp(startingYear: $startingYear, block: $block, dayIndex: $dayIndex)\n    teachingDays(startingYear: $startingYear, block: $block)\n  }\n}\n"
  }
};
})();

(node as any).hash = "e96af741bccd13e1c8d40c354c7cdedf";

export default node;
